import { Link } from "react-router-dom";

import { SITE_NAME } from "../../services/lib/constants.js";
import logoFull from "../../assets/logo.png";

function Logo() {
  return (
    <Link to="/">
      <img
        src={logoFull}
        width="35"
        height="50"
        alt={SITE_NAME}
        title={`${SITE_NAME} logo`}
      />
    </Link>
  );
}

export default Logo;
